import { render, staticRenderFns } from "./MedicalPayments.vue?vue&type=template&id=2987d9a2&scoped=true&"
import script from "./MedicalPayments.vue?vue&type=script&lang=js&"
export * from "./MedicalPayments.vue?vue&type=script&lang=js&"
import style0 from "./MedicalPayments.vue?vue&type=style&index=0&id=2987d9a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2987d9a2",
  null
  
)

export default component.exports